var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-card',{staticClass:"overflow-y-auto",attrs:{"height":_vm.height,"width":"100%"}},[_vm._t("default")],2),_vm._t("toolbar",function(){return [_c('v-toolbar',{staticClass:"mx-0 mt-0",attrs:{"dense":"","no-gutters":"","bottom":""}},[_vm._t("footer")],2)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }